import { Vehicle } from '@acorn-portal/shared/src/services/lookupApi';
import { Address, PcVehicle } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { format } from 'date-fns';
import { IAmendVehiclePart2 } from './get-vehicle-initial-values';

export type LocationProps = {
	state: {
		registration: string;
		yearOfManufacture: number;
		bodyType: string;
	};
};

export const getVehicleDetails = (
	values: IAmendVehiclePart2,
	location: LocationProps,
	vehicleInfo: Vehicle,
	// Values from other risk data
	homeAddress: Address | undefined,
	vehicleUse: string | undefined,
	annualMileage: number | undefined,
): PcVehicle => {
	return {
		overnightAddress: values.overnightAddressIsAway === 'yes' ? { ...values.overnightAddress } : homeAddress,
		isLeftHandDrive: values.isLeftHandDrive === 'yes',
		whereParkedOvernight: values.keptOvernight,
		registration: location.state.registration,
		yearOfManufacture: location.state.yearOfManufacture,
		bodyType: vehicleInfo.bodyType?.code ?? '',
		numberOfDoors: parseInt(vehicleInfo.numberOfDoors?.code ?? '0', 10),
		numberOfSeats: parseInt(vehicleInfo.numberOfSeats ?? '0', 10),
		registeredKeeper: values.registeredKeeper,
		abiCode: vehicleInfo.abicode ?? '',
		engineSize: vehicleInfo.cubicCapacity ?? 0,
		abiGroup: vehicleInfo.abigroup ?? '0',
		fuelType: vehicleInfo.fuelType?.code ?? '',
		transmission: vehicleInfo.transmission?.code ?? '',
		owner: values.owner,
		isImported: values.imported === 'yes',
		value: parseInt(values.value, 10),
		make: vehicleInfo.make?.code ?? '',
		model: vehicleInfo.model?.code ?? '',
		modifications: values.hasModifications === 'yes' ? values.modifications.map((mod) => ({ ...mod })) : [],
		datePurchased: format(
			new Date(parseInt(values.purchasedDate.year, 10), parseInt(values.purchasedDate.month, 10) - 1, 1),
			'yyyy-MM-dd',
		),
		countryOfRegistration: values.countryOfRegistration,
		registrationDate: vehicleInfo.registrationDate ? format(vehicleInfo.registrationDate, 'yyyy-MM-dd') : '',
		grossWeight: parseInt(vehicleInfo.grossWeight ?? '0', 10),
		// these carry over, as the user has the option to change them on the usage and mileage screen
		annualMileage: annualMileage ?? 0,
		vehicleUse: vehicleUse ?? '',
	};
};
